import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineRedoIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 11a1.0001 1.0001 0 0 0-1 1 8.0504 8.0504 0 0 1-1.8143 5.1425 8.0505 8.0505 0 0 1-10.0672 1.9883 8.0502 8.0502 0 0 1-.5278-13.847A8.05 8.05 0 0 1 17.78 6.5h-2.4a1 1 0 1 0 0 2h4.53a1 1 0 0 0 1-1V3a.9997.9997 0 0 0-1-1 1 1 0 0 0-1 1v1.77A9.9998 9.9998 0 0 0 2.3908 9.2302a9.9999 9.9999 0 0 0 17.3563 9.0915A9.9996 9.9996 0 0 0 22 12a.9997.9997 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineRedoIcon
